import React from "react";
import "./NewsCard.css";

const NewsCard1 = () => {
  const handleSourceClick = () => {
    window.open("https://mobile.ghanaweb.com/GhanaHomePage/business/Insurance-Risks-Assured-Life-Mortality-Table-currently-80-complete-NIC-1960344", "_blank");
  };

  return (
    <div>
      <section className="section-council">
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">LATEST NEWS</h2>
      <div className="sectionbottom-line"></div>
      </section>
      <h2 className="newstoptitle">
        Insurance Risks: Assured Life Mortality Table is currently 80% complete - NIC
      </h2>
    <div className="newscard">

      
      <img
        src="images\News\news1.jpg" 
        alt="News"
        className="newsimage"
      />

      
      <h3 className="newstitle">
        The Assured Life Mortality Table is currently 80% complete
      </h3>

    
      <div className="newsmeta">
        <span className="newssource">
          Source:{" "}
          <button onClick={handleSourceClick} className="sourcelink">
            www.ghanaweb.com
          </button>
        </span>
        <span className="newsdate">Mon, 18 Nov 2024</span>
      </div>

      <p className="newsdescription">
        Ghana's actuarial community is nearing a major milestone: the near
        completion of the Assured Life Mortality Table, which aims to transform
        life insurance practices in the country.
        <br />
        <br />
        The project, which is expected to be finalised by the first quarter of
        2025, was highlighted at the 2024 Actuarial Society of Ghana (ASG),
        Actuaries Connect Conference, alongside other initiatives aimed at
        advancing actuarial expertise and improving the broader insurance
        sector.
        <br />
        <br />
        The Assured Life Mortality Table, currently 80% complete, will allow
        life insurers to assess mortality risks with greater accuracy and
        relevance to Ghana's population.
        <br/>
        <br/>
        For years, the industry has relied on international mortality tables that don’t 
        fully capture the demographic realities of the country. Once completed, this table 
        will offer actuaries a data-driven resource to better price life insurance policies, 
        improving both competitiveness and sustainability in the sector.
        <br/>
        <br/>
        Acting Commissioner of the National Insurance Commission, Michael Kofi Andoh   
        emphasised the significance of the project and its impact on the insurance industry. 
        <br/>
        <br/>
        "The Assured Life Mortality Table will help insurers better understand the risks 
        associated with life insurance policies in Ghana, offering more accurate pricing 
        and ultimately strengthening the financial stability of the life insurance market in the country," he said.
        <br/>
        <br/>
        The table is being developed through a collaborative effort between the National Insurance Commission 
        (NIC), ASG, and key stakeholders, and is expected to become a vital tool for life insurers and actuaries alike..
        <br/>
        <br/>
        In addition to the life table, ASG and NIC have launched a mentorship initiative 
        aimed at guiding and supporting the next generation of actuaries. 
        <br/>
        <br/>
        The program seeks to connect seasoned actuaries with students and young professionals, 
        offering invaluable advice, career coaching, and practical insights into the insurance industry.
        <br/>
        <br/>
        "Mentorship is crucial to ensuring that our future actuaries are equipped with the skills 
        and knowledge needed to succeed," President of the Actuarial Society of Ghana, Neil Tagoe told the media. 
        <br/>
        <br/>
        "The actuarial profession is evolving rapidly, and this initiative will help young professionals 
        gain the expertise and ethical grounding required to navigate the complexities of the field," he added.
        <br/>
        <br/>
        The mentorship program aims to address the growing demand for qualified actuaries in Ghana by 
        fostering a new generation of professionals who are prepared to meet the challenges of a changing insurance landscape. 
        <br/>
        <br/>
        Experienced actuaries will share their knowledge from technical skills to the nuances of 
        ethical practice, helping to bridge the gap between academic study and industry needs.
        <br/>
        <br/>
        Meanwhile, the NIC continues to significantly improve the overall actuarial capacity 
        within Ghana’s insurance sector. One of the major projects highlighted at the conference \
        was the UNDP-Milliman Global Actuarial Initiative (GAIN), which is currently training 
        28 actuarial staff from 17 non-life insurance companies in Ghana. 
        <br/>
        <br/>
        The training is designed to equip non-life insurers with the actuarial tools needed to 
        better assess risk and improve financial reporting.
        <br/>
        <br/>
        Additionally, the NIC has finalised an inclusive insurance strategy aimed at expanding 
        access to affordable insurance products, particularly for underserved populations. 
        <br/>
        <br/>
        This initiative is expected to help create more inclusive, accessible insurance 
        solutions that cater to a broader segment of the Ghanaian population.
        <br/>
        <br/>
        The 2024 Actuarial Society of Ghana (ASG) Connect Conference was climaxed with the 
        induction of new executives to steer the affairs of the society.
        <br/>
        <br/>
        They are: Kofi Ntim, MiLife Insurance - President; Kakra Duffuor-Nyarko, 
        StarLife - Vice President; Magnus Owusu-Agyemang, NHIA, Financial Secretary; Harris Yemoh, SSNIT, Secretary.
        <br/>
        <br/>
        MA
      </p>
    </div>
    </div>
  );
};

export default NewsCard1;
